import React from 'react';
import Feature from '../../Feature';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

export default function FeaturesSection({ sectionTitle, data, sectionSubTitle }) {
  return (
    <section id="services" className="bg-cream py-16 md:py-28">
      <div className="max-w-[1200px] mx-auto px-6 md:px-16">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-10 md:mb-16 gap-6 md:gap-8">
          <div className="max-w-[500px]">
            <div className="inline-flex items-center gap-[0.6rem] text-[0.72rem] tracking-[0.2em] uppercase text-gold font-medium mb-4">
              <span className="w-[24px] h-px bg-gold block"></span>
              {sectionTitle || "What We Offer"}
            </div>
            <h2 className="font-serif text-[2rem] md:text-[3rem] font-light leading-[1.2] text-charcoal mb-0">
              {sectionSubTitle ? parse(sectionSubTitle) : parse("Comprehensive <em className='italic text-crimson'>services</em> for every need")}
            </h2>
          </div>
          <Link to="/contact" className="inline-block bg-crimson text-white px-9 py-3.5 text-xs font-medium tracking-[0.12em] uppercase rounded-[2px] transition-all duration-250 hover:bg-crimson-dark hover:-translate-y-px hover:shadow-lg whitespace-nowrap">
            Get in Touch
          </Link>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[1.5px] bg-cream-dark border border-cream-dark rounded-md overflow-hidden">
          {data?.map((item, index) => (
            <div key={index}>
              <Feature {...item} />
            </div>
          ))}
        </div>
        
        {/* Optional Community photo banner inside services, rendered conditionally if passing a prop or hardcoded to preserve brand identity */}
        <div className="mt-8 md:mt-12 rounded-md overflow-hidden relative h-[220px] md:h-[320px]">
          <img src="/gallery/Noohra-Services16.jpg" alt="Noohra community outreach session" className="w-full h-full object-cover object-[center_30%]" onError={(e) => { e.target.onerror = null; e.target.src = "/images/home_1/Noohra-Services9.webp"; }} />
          <div className="absolute inset-0 bg-gradient-to-r from-[rgba(139,26,26,0.85)] to-[rgba(139,26,26,0.2)] flex items-center p-8 md:p-12 hidden md:flex">
            <div>
              <div className="text-[0.72rem] tracking-[0.2em] uppercase text-gold-light font-medium mb-3">In the Community</div>
              <p className="font-serif text-[1.8rem] font-light text-white max-w-[420px] leading-[1.4] italic m-0">
                "Taking mental health conversations beyond the clinic &mdash; into communities, schools, and organizations."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
